import { render, staticRenderFns } from "./BetgameEditIcon.vue?vue&type=template&id=adc00d38&scoped=true"
import script from "./BetgameEditIcon.vue?vue&type=script&lang=js"
export * from "./BetgameEditIcon.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditIcon.vue?vue&type=style&index=0&id=adc00d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc00d38",
  null
  
)

export default component.exports